import TaxiCorporationDriverPlanRequest from "../../../../api/raily/taxi-corporation/driver/plan/taxi-corporation-driver-plan.request";
import TaxiCorporationDriverPlanParams from "./taxi-corporation-driver-plan-params";

const create = (
  params: TaxiCorporationDriverPlanParams,
): TaxiCorporationDriverPlanRequest => {
  return {
    driverUuid: params.driverUuid,
    taxiCorporationUuid: params.taxiCorporationUuid,
  };
};

const taxiCorporationDriverPlanParams = {
  create,
};

export default taxiCorporationDriverPlanParams;
